export default {
  state: {
    id: undefined,
    name: undefined,
    date: undefined,
    author: undefined,
    copyright: undefined,
    solution: undefined,
    grid: undefined,
    width: undefined,
    height: undefined,
    circles: undefined,
    diagramless: undefined,
    encrytped: false,
    notes: undefined,
    created_at: undefined,
    updated_at: undefined,
    is_public: true,
    checksum: undefined,
    etag: undefined,
    puzzle_link_id: undefined,
    provider_id: undefined,
    purchasable: true,
    multichars: undefined,
    import_id: undefined,
    characters: undefined,
    locked: false,
    public: false,
    solution_checksum: undefined,
    multichars_checksum: undefined,
    difficulty: 50,
    free: false,
    multichars_checksum_order: undefined,
    puzzle_bundle_id: undefined,
    puzzle_author_id: undefined,
    arrow: undefined,
    asset_uuid: undefined,
    puzzle_type: undefined,
    source_file: undefined,
    type: undefined,
    loading: false,
    attachments: [],
    author_ids: [],
    contributor_ids: [],
    editor_ids: [],
    authors: [],
    contributors: [],
    editors: [],
    newsletters: [],
    provider: {},
    purchasable_item: {},
    relationships: {},
    puzzle_types: [],
    tags: [],
    external_ids: {}
  }
}



// WEBPACK FOOTER //
// ./src/stores/PuzzleStore.js